import React, { forwardRef } from 'react';
import PrdcUnitItem from '@wconcept/wconcept-ui-renewal/src/components/molecules/_item/PrdcUnitItem';
import { getExclusiveEmblemProp } from '@utils/productExclusiveUtil';
import { ProductGridItemProps } from '../types';

const ProductGridItem = forwardRef<HTMLDivElement, ProductGridItemProps>(
  (
    {
      product,
      originalIndex,
      isMobile,
      isLogin,
      myHeartList,
      showExclusiveEmblem,
      mobileVirtualColumnCount = 2,
      onClickProduct,
      onClickHeart,
    },
    ref
  ) => (
    <PrdcUnitItem
      isDesktop={!isMobile}
      isLogin={isLogin}
      priority
      ref={ref}
      itemCd={product.itemCd}
      statusCd={product.statusCd}
      finalPrice={product.finalPrice}
      customerPrice={
        mobileVirtualColumnCount === 3 ? undefined : product.customerPrice
      }
      finalDiscountRate={product.finalDiscountRate}
      reviewScore={product.reviewScore}
      reviewCnt={product.reviewCnt}
      hideHeartCnt={mobileVirtualColumnCount === 3}
      heartCnt={mobileVirtualColumnCount === 3 ? undefined : product.heartCnt}
      reserveTag={product.reserveTag}
      saleTag={product.saleTag}
      infoTags={product.infoTags}
      imageUrl={product.imageUrlMobile || product.productImageUrl}
      exclusive={getExclusiveEmblemProp(product, showExclusiveEmblem)}
      brandCd={product.brandCd}
      brandNameKr={product.brandNameKr}
      itemNameSub={product.itemNameSub}
      itemName={product.itemName}
      myHeartItem={product.itemCd ? !!myHeartList?.has(product.itemCd) : false}
      todayDeliveryTag={product.todayDeliveryTag}
      colors={product.colors}
      onClick={({ heartCnt }) =>
        onClickProduct({ ...product, heartCnt }, originalIndex)
      }
      onClickHeart={async (itemCd, isActive, heartCnt) =>
        onClickHeart?.({ ...product, heartCnt }, isActive, originalIndex)
      }
    />
  )
);

ProductGridItem.displayName = 'ProductGridItem';

export default ProductGridItem;
